import { useSyncExternalStore } from 'react'
import type { To } from 'react-router-dom'
import { orgHrefFor, withTabOrganization } from '@/lib/org-href'
import {
  getIsUrlOrganizationRejected,
  getUrlOrganizationId,
  subscribeToTabOrganization,
} from '@/lib/tab-organization'

export function useIsUrlOrganizationRejected(): boolean {
  return useSyncExternalStore(subscribeToTabOrganization, getIsUrlOrganizationRejected)
}

export function useUrlOrganizationId(): string | null {
  return useSyncExternalStore(subscribeToTabOrganization, getUrlOrganizationId)
}

export function useOrgTo(to: To): To {
  const organizationId = useUrlOrganizationId()
  return withTabOrganization(to, organizationId)
}

export function useOrgHref(path: string): string {
  const organizationId = useUrlOrganizationId()
  return orgHrefFor(path, organizationId)
}
